class ClubsSelectorComponent extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('[data-ref="clubs-overlay"]');
    this.toggleBtn = this.querySelector('[data-ref="clubs-toggle"]');
    this.closeBtns = this.querySelectorAll('[data-ref="clubs-close"]');

    // Déplacer l'overlay dans le body pour éviter les problèmes de stacking context
    // (similaire au comportement de ModalDialog dans Dawn)
    if (this.overlay && this.overlay.parentElement !== document.body) {
      document.body.appendChild(this.overlay);
    }

    this.toggleBtn?.addEventListener('click', () => this.open());
    this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.close()));

    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });
  }

  open() {
    this.overlay.classList.remove('is-closing');
    this.overlay.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    setTimeout(() => this.overlay.querySelector('[data-ref="clubs-close"]')?.focus(), 150);
  }

  close() {
    this.overlay.classList.add('is-closing');
    setTimeout(() => {
      this.overlay.classList.remove('is-open', 'is-closing');
      document.body.classList.remove('overflow-hidden');
      this.toggleBtn?.focus();
    }, 125);
  }

  get isOpen() {
    return this.overlay?.classList.contains('is-open') ?? false;
  }
}

if (!customElements.get('clubs-selector-component')) {
  customElements.define('clubs-selector-component', ClubsSelectorComponent);
}

class SearchableSelect extends HTMLElement {
  #initialized = false;

  connectedCallback() {
    // Éviter la double initialisation après le déplacement de l'overlay dans le body
    if (this.#initialized) return;
    this.#initialized = true;

    const blockId = this.dataset.id;
    const inputId = this.dataset.inputId;

    this.searchInput = this.querySelector(`#searchInput-${blockId}`);
    this.optionsList = this.querySelector(`#optionsList-${blockId}`);
    this.limit = parseInt(this.getAttribute('limit')) || 0;
    this.formInput = document.querySelector(`#${inputId}`);

    // Recherche par data-block dans tout le document (fonctionne même après déplacement dans body)
    this.selectedValuesDisplays = document.querySelectorAll(
      `.clubs-selector__tags[data-block="${blockId}"]`
    );

    this.#setupSearch();
    this.#setupSelection();
  }

  #setupSearch() {
    this.searchInput?.addEventListener('input', () => {
      const filter = this.searchInput.value.toLowerCase();
      this.optionsList.querySelectorAll('li').forEach((option) => {
        const text = option.textContent.toLowerCase();

        if (filter.length === 0) {
          option.style.display = option.hasAttribute('data-selected') ? 'flex' : 'none';
          return;
        }

        if (filter.length < 2) {
          option.style.display =
            text.includes(filter) && option.hasAttribute('data-selected') ? 'flex' : 'none';
          return;
        }

        option.style.display = text.includes(filter) ? 'flex' : 'none';
      });
    });
  }

  #setupSelection() {
    this.optionsList?.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if (!li) return;

      li.classList.toggle('selected');

      if (this.limit > 0) {
        const selectedCount = this.optionsList.querySelectorAll('li.selected').length;
        if (selectedCount > this.limit) {
          li.classList.toggle('selected');
          return;
        }
      }

      this.#updateSelectedValues();
    });
  }

  #updateSelectedValues() {
    const selectedOptions = this.querySelectorAll('#optionsList-' + this.dataset.id + ' li.selected');

    if (this.formInput) {
      this.formInput.value = Array.from(selectedOptions)
        .map((opt) => opt.getAttribute('data-value'))
        .join(',');
    }

    const values = Array.from(selectedOptions).map((opt) => ({
      value: opt.getAttribute('data-value'),
      name: opt.textContent.trim(),
    }));

    this.selectedValuesDisplays.forEach((container) => {
      container.innerHTML = '';
      container.append(
        ...values.map((v) => {
          const tag = document.createElement('div');
          tag.classList.add('clubs-selector__tag');
          tag.setAttribute('data-value', v.value);

          const text = document.createElement('span');
          text.textContent = v.name;

          const removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.setAttribute('aria-label', 'Retirer ' + v.name);
          removeBtn.innerHTML = '<span class="material-symbols-outlined notranslate" translate="no">close</span>';
          removeBtn.addEventListener('click', () => {
            tag.remove();
            this.#deselectOption(v.value);
            this.#updateSelectedValues();
          });

          tag.appendChild(text);
          tag.appendChild(removeBtn);
          return tag;
        })
      );
    });
  }

  #deselectOption(value) {
    const option = this.optionsList?.querySelector(`li[data-value="${value}"]`);
    option?.classList.remove('selected');
  }
}

if (!customElements.get('searchable-select')) {
  customElements.define('searchable-select', SearchableSelect);
}
